import * as React from "react";

const NUM_STEPS = 8;

interface StatusBarProps {
    maxFill: number;
}

function joinArray<P>(arr: P[], el: P): P[] {
    const result = []
    for (let x = 0; x < arr.length; x++) {
        result.push(arr[x])
        if (x != arr.length - 1) {
            result.push(el);
        }
    }
    return result;
}

export function StatusBar({ maxFill }: StatusBarProps): JSX.Element {
    const progress = new Array(NUM_STEPS)
        .fill(null)
        .map((_, idx: number) => {
        return idx <= maxFill ?
            <div className="fill">&nbsp;</div> :
            <div>&nbsp;</div>
    });
    return (
        <div className="status-bar">
            { joinArray<React.ReactNode>(progress, <hr />) }
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/ts/components/calculator/status_bar.tsx